import { Link, useNavigate } from "react-router-dom";

import { getPaywallType, getFunnelType } from "src/appConfig";
import styles from "./styles.module.scss";
import { DATA } from "./data";
import { useEffect, useState } from "react";
import nextImage from "../peopleChosen/img/bg.jpg";
import authService from "@api/services/authService";
import { UserService } from "@api/services/userService";
import { updateDataLayer } from "@utils/updateDataLayer";
import { errorToast } from "@utils/toaster";
import { Loader } from "@common/loader";

export const StartJourney = ({ onNextStep, onTrackEvent }) => {
  useEffect(() => {
    updateDataLayer({
      event: "FirstQuestionShown",
      userId: localStorage.getItem("userId"),
    });
  }, []);

  const handleNextStep = (value) => {
    onNextStep(value);
    onTrackEvent(value);
  };

  return (
    <div className={styles.container} id="breakdown">
      <h1>Start your fitness journey</h1>
      <p className={styles.choose}>Choose your age bracket</p>
      <p className={styles.quiz}>1-min quiz</p>
      <div className={styles.cards}>
        {DATA.map((item) => (
          <div
            key={item.value}
            onClick={() => handleNextStep(item.value)}
            className={styles.card}
          >
            <img src={item.image} alt={item.value} />
            <div className={styles.label}>Age: {item.value}</div>
          </div>
        ))}
      </div>
      <p className={styles.privacy}>
        By choosing your age and continuing you agree to our{" "}
        <Link to="/terms-of-use">Terms of Service</Link> |
        <Link to="/privacy-policy"> Privacy Policy</Link>.<br />
        Please review before continuing.
      </p>
    </div>
  );
};
